import { TokenResponse, useGoogleLogin } from '@react-oauth/google';

import Button from 'components/Button/Button';

interface GoogleSignUpProps {
  onSuccess: (response: TokenResponse) => void;
}

const GoogleSignUp: React.FC<GoogleSignUpProps> = ({ onSuccess }) => {
  const googleLogin = useGoogleLogin({
    onSuccess,
    onError: () => {}
  });

  return (
    <Button
      leftIcon={
        <img
          src="https://media.appcharge.com/defaults/google_icon.svg"
          alt="google icon"
          className="w-4 h-4"
        />
      }
      variant="outline"
      onClick={() => googleLogin()}
      className="w-full shadow-sm"
    >
      Continue with Google
    </Button>
  );
};

export default GoogleSignUp;
